import { render, staticRenderFns } from "./DocumentAreaStock.vue?vue&type=template&id=06d54044&scoped=true"
import script from "./DocumentAreaStock.vue?vue&type=script&lang=js"
export * from "./DocumentAreaStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d54044",
  null
  
)

export default component.exports